<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap2">ONE</h1>
<h1 class="center">“Who is like unto the beast?”</h1>
<h1 class="center">—<i>Revelation</i> 13:4</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6chap2.vue?245bde42